import React from 'react'
import { Button, Card, Col, Collapse, Input, Row, Space, Typography } from 'antd'
import PropTypes from 'prop-types'
import { ImageUploaderToS3 } from '~components'
import { Label, MultiSelectDropdown } from '~stories'
import DownArrow from '../PositionArrows/DownArrow'
import UpArrow from '../PositionArrows/UpArrow'

const { Panel } = Collapse
const { Title, Text } = Typography

const SOURCE_TYPE = [{
  label: 'Image',
  value: 'image'
}, {
  label: 'Video',
  value: 'video'
}]

const DatafieldGallery = ({
  galleries,
  deleteGallery,
  handleGalleryChange,
  handleGalleryMediaChange,
  handleGalleryImageAltChange,
  handleGalleryImageUrlUpdate,
  handleGallerySubTitleChange,
  handleGalleryTitleChange,
  setGallery
}) => {
  const handleMoveUp = (event, id) => {
    event.stopPropagation()
    const tempList = [...galleries]
    if (id > 0) {
      const el = tempList[id]
      tempList[id] = tempList[id - 1]
      tempList[id - 1] = el
      setGallery([...tempList])
      handleGalleryChange && handleGalleryChange([...tempList])
    }
  }
  const handleMoveDown = (event, id) => {
    event.stopPropagation()
    const tempList = [...galleries]
    if (id !== -1 && id < tempList.length - 1) {
      const el = tempList[id]
      tempList[id] = tempList[id + 1]
      tempList[id + 1] = el
      setGallery([...tempList])
      handleGalleryChange && handleGalleryChange([...tempList])
    }
  }
  return (
    <Card style={{ border: '1px solid rgb(32, 32, 34)' }}>
      <Row gutter={16}>
        <Col span={24}>
          <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right'>
            {
              galleries?.map((gallery, galleryIndex) => (<Panel key={galleryIndex}
                extra={<Row gutter={2}><Space>
                  <Col align="left" span={4}>
                    <Row gutter={[10]} style={{ width: '60px' }}>
                      {galleryIndex !== 0 && <Col align='right' data-testid="up-arrow" onClick={(event) => handleMoveUp(event, galleryIndex)} span={12}>
                        <UpArrow />
                      </Col>
                      }
                      {galleries.length - galleryIndex !== 1
                        ? <Col align="left" data-testid="down-arrow" onClick={(event) => handleMoveDown(event, galleryIndex)} span={12}>
                          <DownArrow/>
                        </Col>
                        : <Col span={3} />}
                    </Row>
                  </Col>
                  <Button danger disabled={gallery.cta} onClick={(event) => deleteGallery(event, galleryIndex)} style={{ backgroundColor: '#DA0D50', color: '#fff' }}>Delete</Button>
                </Space>
                </Row>
                }
                header={<span style={{
                  fontSize: 20
                }}>{gallery?.title}</span>}
              > <Card style={{ width: '100%', marginTop: 8 }}>
                  <Row gutter={16}>
                    <Col span={24}>
                      <Row gutter={16}><Title level={5}>Title*</Title>&nbsp;<Text>(70 characters max)</Text></Row>
                      <Input onChange={(event) => handleGalleryTitleChange(event, galleryIndex)} value={gallery?.title} />
                    </Col>
                  </Row><br/>
                  <Row gutter={16}>
                    <Col span={24}>
                      <Row gutter={16}><Title level={5}>Caption</Title></Row>
                      <Input onChange={(event) => handleGallerySubTitleChange(event, galleryIndex)} value={gallery?.subtitle} />
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={18}>
                      <Row gutter={16}>
                        <Col span={8}>
                          <MultiSelectDropdown
                            allowClear={true}
                            customStyle={{ width: 150 }}
                            displayField='label'
                            dropdownOptions={SOURCE_TYPE}
                            handleChange={(selectedItems) => handleGalleryMediaChange(selectedItems, galleryIndex)}
                            label='Media Type'
                            selectedItems={gallery?.mediaType}
                            valueField='value'
                          />
                        </Col>
                      </Row>
                      {
                        gallery?.mediaType === 'image' && <><Label value='Image' />
                          <div>
                            <Row gutter={16}>
                              <ImageUploaderToS3 handleUpload={(url) => handleGalleryImageUrlUpdate(url, galleryIndex)} logoUrl={gallery?.src} />
                            </Row>
                            <Row gutter={16}>
                              <Col span={8}>
                                <Row gutter={16}>Alt</Row>
                                <Input onChange={(event) => handleGalleryImageAltChange(event, galleryIndex)} value={gallery?.alt} />
                              </Col>
                            </Row>
                          </div></>
                      }
                      {
                        gallery?.mediaType === 'video' && <><Label value='Video Url' />
                          <div>
                            <Row gutter={16}>
                              <Col span={24}>
                                <Input onChange={(event) => handleGalleryImageUrlUpdate(event.target.value, galleryIndex)} value={gallery?.src} />
                              </Col>
                            </Row>
                          </div></>
                      }
                    </Col>
                  </Row>
                </Card>
              </Panel>)
              )}
          </Collapse>
          <br />
        </Col>
      </Row>
    </Card>
  )
}

DatafieldGallery.propTypes = {
  deleteGallery: PropTypes.func,
  galleries: PropTypes.array,
  handleGalleryChange: PropTypes.func,
  handleGalleryImageAltChange: PropTypes.func,
  handleGalleryImageUrlUpdate: PropTypes.func,
  handleGalleryMediaChange: PropTypes.func,
  handleGallerySubTitleChange: PropTypes.func,
  handleGalleryTitleChange: PropTypes.func,
  setGallery: PropTypes.func
}

DatafieldGallery.defaultProps = {
  galleries: []
}

export default DatafieldGallery
